import type { AitypesInsight, GetAiInsightsData } from '@polaris/api-client'
import { apiClient } from './client'

export const getInsight = async (id: string): Promise<AitypesInsight> => {
  const response = await apiClient.get(`ai/insight/${id}`, {
    next: {
      revalidate: 60, // 1 minute
    },
  })

  return response.json<AitypesInsight>()
}

export type GetInsightsOptions = GetAiInsightsData['query']

export const getInsightsQueryHomepageOptions: GetInsightsOptions = {
  _start: 0,
  _end: 7,
  _sort: 'publishedAt',
  _order: 'desc',
  published: true,
  type: 'curated',
}

export const getInsights = async (options: GetInsightsOptions) => {
  const response = await apiClient.get('ai/insights', {
    searchParams: options,
    next: {
      revalidate: 60, // 1 minute
    },
  })

  return response.json<AitypesInsight[]>()
}
